<script lang="ts">
    import {Component, toNative} from 'vue-facing-decorator'
    import __OrderDetails, {OrderDetails as _OrderDetails} from '~src/components/account/OrderDetails.vue'

    @Component({mixins: [__OrderDetails]})
    export class OrderDetails extends _OrderDetails {
        // UI-21 (Point B - Attachments): Remove the "Attachments" section from the
        // order (reservation) view. The Attachments tab is only pushed for B2B/Extranet
        // viewers in the core `get tabs()`; filtering it out here hides the tab and its
        // content panel (OrderDetailsAttachments) for the ZSH customization, while
        // leaving core behavior untouched for other builds.
        get tabs() {
            return super.tabs.filter(tab => tab.name !== 'attachments')
        }

        // UI-22 (Point C - Google Maps): Remove the Google Maps section from the
        // order (reservation) view. `isShowMap` gates both the desktop map panel
        // (`v-if="isShowMap && !isMobile"`, which renders <OrderDetailsMap>) and the
        // mobile 'map' tab; returning false hides both for the ZSH customization,
        // while leaving core behavior untouched for other builds.
        get isShowMap() {
            return false
        }
    }

    export default {...toNative(OrderDetails), ssrRender: __OrderDetails.ssrRender}
</script>
